import IMask from 'imask';

export function createInputmask(id, mask = "+{7}(000)-000-00-00") {
    IMask(document.getElementById(id), { mask });
}


// WEBPACK FOOTER //
// ./_src/js/Inputmask.js